<template>
  <div class="contract-list">
    <el-row class="filter-wrap" :gutter="20">
      <el-col :span="5">
        <el-input clearable v-model="page.nameOrCode" size="small" placeholder="框架合同名称/编号" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="5">
        <el-input clearable v-model="page.customerName" size="small" placeholder="客户名称" @keyup.enter.native="onSearch"></el-input>
      </el-col>
	  <el-col :span="5">
	    <el-input clearable v-model="page.businessPrincipal" size="small" placeholder="有花果对接负责人" @keyup.enter.native="onSearch"></el-input>
	  </el-col>
      <el-col :span="4" class="input-group">
        <el-select clearable v-model="page.status" size="small" placeholder="盖章状态" @change="getList()" class="w-100">
          <el-option v-for="(item, index) in sealStatus" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
		<el-button @click="resetForm()">重置</el-button>
        <el-button type="primary" size="small" @click="onSearch">查询</el-button>
      </el-col>
    </el-row>
	<div style="margin-top: 30px;">
		<div style="margin: 20px 0;">框架合同总数：{{this.page.total||0}}</div>
			<el-table v-loading="tableLoading" :data="tableData" size="small">
				<el-table-column label="框架合同信息" prop="bankSerialNumber" align="center">
					<template slot-scope="scope">
						<div>合同名称:{{scope.row.name}}</div>
						<div>合同编号:{{scope.row.code}}</div>
					</template>
				</el-table-column>
				<el-table-column label="客户名称" prop="customerName" align="center"></el-table-column>
				<el-table-column label="客户类型" prop="customerType" align="center">
					<template slot-scope="scope">
							<span v-if="scope.row.customerType==1">品牌方</span>
							<span v-else-if="scope.row.customerType==2">Agency</span>
					</template>
				</el-table-column>
				<el-table-column label="合同状态" prop="status" align="center">
					<template slot-scope="scope">
							<span v-if="scope.row.status==1">洽谈中</span>
							<span v-else-if="scope.row.status==2">已签约</span>
					</template>
				</el-table-column>
				<el-table-column label="对接负责人" prop="principalName" align="center"></el-table-column>
				<el-table-column label="合同开始日期" prop="beginTime" align="center"></el-table-column>
				<el-table-column label="合同结束日期" prop="endTime" align="center"></el-table-column>
				<el-table-column label="框架协议文件" prop="fileList" align="center">
				  <template slot-scope="scope">
					<span v-if="!scope.row.fileList">--</span>
					<filePreview :fileList="scope.row.fileList"></filePreview>
					<!-- <a style="display: block;" v-for="(item,index) in scope.row.fileList" v-if="item.fileType == 2" :key='index' class="link" href="javascript:void(0);" @click="downloadFile(item.path,item.name)" :download="item.path">{{item.name}}</a> -->
				  </template>
				</el-table-column>
				<el-table-column label="盖章状态" prop="sealStatus" align="center">
					<template slot-scope="scope">
							<span v-if="scope.row.sealStatus==1">待申请盖章</span>
							<span v-else-if="scope.row.sealStatus==2">盖章审核中</span>
							<span v-else-if="scope.row.sealStatus==3">盖章审核不通过</span>
							<span v-else-if="scope.row.sealStatus==4">待盖章</span>
							<span v-else-if="scope.row.sealStatus==5">已盖章</span>
							<span v-else-if="scope.row.sealStatus==6">已作废</span>
							<span v-else>——</span>
					</template>
				</el-table-column>
				
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="gzEdit(scope.row.id)">编辑</el-button>
						<el-button type="text" size="small" @click="goSee(scope.row.id)">查看</el-button>
						<template v-if="scope.row.sealStatus==1">
							<el-button type="text" size="small" @click="sqgz(scope.row.id,1)">申请盖章</el-button>
							<el-button type="text" size="small" @click="delKjxy(scope.row.id)">删除</el-button>
						</template>
						<template v-else-if="scope.row.sealStatus==2">
							<el-button type="text" size="small" @click="gzInfo(scope.row.id)">盖章审批详情</el-button>
						</template>
						<template v-else-if="scope.row.sealStatus==3">
							<el-button type="text" size="small" @click="gzInfo(scope.row.id)">盖章审批详情</el-button>
							<el-button type="text" size="small" @click="sqgz(scope.row.id,2)">重新申请盖章</el-button>
							<el-button type="text" size="small" @click="delKjxy(scope.row.id)">删除</el-button>
						</template>
						<template v-else-if="scope.row.sealStatus==5">
							<el-button type="text" size="small" @click="zfClick(scope.row.id)">作废</el-button>
						</template>
						<template v-else-if="scope.row.sealStatus==6">
							<el-button type="text" size="small" @click="sqgz(scope.row.id,2)">重新申请盖章</el-button>
						</template>
					</template>
				</el-table-column>
			</el-table>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
          layout="sizes, prev, pager, next, jumper" :total="page.total">
        </el-pagination>
      </div>
      <!-- 分页 -->
    </div>
    <!-- 盖章审批详情 -->
    <el-dialog title="盖章审批详情" :visible.sync="Invoicedialog">
      <el-form :model="gzData" ref="gzData" :rules="rules" label-width="130px">
        <el-form-item label="上一审批人:"  class="block-form-item w-32" style="width: 40%;">
          <el-input v-model="gzData.approveName" disabled></el-input>
        </el-form-item>
		<el-form-item label="待审批人:"  class="block-form-item w-32" style="width: 40%;">
		  <el-input v-model="waitApproveNameList" disabled></el-input>
		</el-form-item>
        <el-form-item label="审批状态:"  class="" style="width:40%;">
          <el-select v-model="gzData.auditStatus" class="w-100" disabled>
               <el-option v-for="(item,index) in statusList" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审批备注:"  class="block-form-item w-99">
          <el-input type="textarea" maxlength="300" show-word-limit v-model="gzData.auditRemark" disabled></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 申请盖章 -->
    <el-dialog :title="sqType==1?'申请盖章':'重新申请盖章'" :visible.sync="sqVisible" width="40%">
	  <el-form :model="zfData" ref="zfData" :rules="rules" label-width="120px">
			<el-form-item label="框架协议附件:" prop="name" class="block-form-item">
				<moreAccessories  ref="uploadBtn" buttonTitle="上传框架协议" @moreClick="moreClickA"></moreAccessories>
<!-- 				<el-upload  class="upload-demo" :action="'https://upload-z2.qiniup.com'" :before-upload="beforeUpload">
					<a style="display: block;" class="link" href="javascript:void(0);"  @click="downloadFile(zfData.fileList[0].path,zfData.fileList[0].name)" :download="zfData.fileList[0].path">{{zfData.fileList[0].name}}</a>
					<el-button  size="small" type="primary">上传框架协议文件</el-button>
				</el-upload> -->
			</el-form-item>
			<el-form-item label="盖章类型:" prop="name" class="block-form-item ">
			  <el-select v-model="zfData.sealType" class="w-100">
				  <el-option v-for="(item,index) in sealType" :label="item.label" :value="item.value"></el-option>
			  </el-select>
			</el-form-item>
			  <el-form-item label="盖章经办人:" prop="name" class="block-form-item w-16">
				<el-input :value="zfData.name" disabled>
				  <i slot="append" @click="$refs.sealp.adminListModal=true"  class="iconfont icon-xialaxuanze_xialaduoxuan"></i>
				</el-input>
			  </el-form-item>
			  <div class="mar-c">
				<el-button type="primary" v-if="sqType==1" size="small" @click="submitSqgz()" :disabled="submitLoading">申请盖章</el-button>
				<el-button type="primary" v-else size="small" @click="submitSqgz()" :disabled="submitLoading">重新申请盖章</el-button>
				<el-button type="primary"  size="small" @click="sqComit()" :disabled="submitLoading">保存</el-button>
			  </div>
	  </el-form>
    </el-dialog>
	<!-- //盖章经办人弹框 -->
	<sealPeople ref="sealp" @select="selectPeople"></sealPeople>
  </div>
</template>

<script>
import moreAccessories from "@/components/common/moreAccessories";//多文件上传
import sealPeople from "@/components/common/sealPeople";//引入选择盖章经办人
import * as qiniu from "qiniu-js";
import { qiniuToken } from "@/api/index";
import { mapGetters } from "vuex";
import validate from "@/util/validate";
import util from "@/util/util";
import { contractConfig } from "@/const/config/contract";
import InvoiceFormFields from "@/const/form/InvoiceForm";
import { billingConfig } from "@/const/config/billing";
import {
	getXyList,delXy,sqSeal,resetSq,getGzInfo,ZFAgree,bcSeal,sealFile
} from "../index.js";
import { processList } from "@/api/approve/contract";
import approveList from "@/components/common/approveMember";
export default {
  components: {
	sealPeople,moreAccessories
  },
  data() {
    // 开票金额判断
    var validPrice = (rule, value, callback) => {
      let money = this.remainingMoney;
      if (!validate.checkNull(value)) {
        let err = validate.checkAmount(value, money);
        if (err) {
          callback(new Error(err));
        }
        callback();
      }
      callback();
    };
    return {
	  sqType:1,//1申请盖章 2重新申请盖章
	  waitApproveNameList:'',
	  statusList:[
		   {label:'待4级审批',value:11},
		   {label:'4级审批不通过',value:12},
		   {label:'待3级审批',value:13},
		   {label:'3级审批不通过',value:14},
		   {label:'待2级审批',value:15},
		   {label:'2级审批不通过',value:16},
		   {label:'待1级审批',value:17},
		   {label:'1级审批不通过',value:18},
		   {label:'待法务级审批',value:19},
		   {label:'法务审批不通过',value:20},
		   {label:'待老板审批',value:21},
		   {label:'老板审批不通过',value:22},
		   {label:'待HR审批',value:23},
		   {label:'HR审批不通过',value:24},
		   {label:'待法务复审审批',value:25},
		   {label:'法务复审批不通过',value:26},
		   {label:'审批通过',value:27},
	  ],
	  gzData:'',//盖章详情
      id:'',//框架协议id
	  sealType:[
	  		  {label:'公章',value:1},
	  		   {label:'合同章',value:2},
	  ],//盖章类型
	  sqVisible:false,//申请开关
	  hkid:'',//单个回款id
	  hkType:[
		  {label:'商务合同回款',value:1},
		  {label:'品牌合同回款',value:2},
	  ],//回款类型
	  rlList:[
		  {label:'未认领',value:1},
		  {label:'部分认领',value:2},
		  {label:'完全认领',value:3},
	  ],//认领状态1未认领 2部分认领 3完全认领
	  sealStatus:[
	  		  {label:'待申请盖章',value:1},
	  		   {label:'盖章审核中',value:2},
	  		   {label:'盖章审核不通过',value:3},
	  		   {label:'待盖章',value:4},
	  		   {label:'已盖章',value:5},
	  		   {label:'已作废',value:6},
	  ],//盖章状态
	  rlData:[],//认领记录
	  zfData:{
		  fileList:[
			  {
			    "fileType": 2,
			    "name": "",
			    "path": ""
			  }
		  ],
		  sealType:null,
		  sealOperatorId: "",
		  name:'',
	  },//作废信息
	  fileList: [],//凭证
      billingConfig,
      approveVisible: false,
      approveLoading: false,
	  Invoicedialog: false, //回款详情
	  approveTitle:false,
	  invoiceVisible: false,//作废详情
	  zftxVisible:false,//作废提醒
      /**
       * 开票提醒模块
       */
      isUploadFile: false, //是否上传
      hasCorrectIncome: false, //KOL收入+有花果收入=净收入
      hasRemainingMoney: false, //剩余金额大于可开票金额


      contractConfig: contractConfig,
      form: {
        nameOrCode: "",
        customerName: "",
        contractMoneyMin: "",
        contractMoneyMax: "",
        statusList: "",
      },
      InvoiceForm: {
			account: "",
			bankAccount: null,
			bankDeposit: "",
			bankSerialNumber: "",
			claimMoney: null,
			createTime: "",
			createUserId: "",
			createUserName: "test",
			deleteFlag: null,
			payeeName: "",
			payer: "",
			remark: "",
			returnMoney: 0,
			returnTime: "",
			returnType: 1,
			status: 1,
			voucher: "",
			waitClaimMoney: 0,
      },
      rules: {
		  hetong22:[
		    { required: true, message: '请先上传框架协议', trigger: 'change' }
		  ],
			sealType22: [
			  { required: true, message: '请选择', trigger: 'blur' }
			],
			name: [
			  { required: true, message: '请选择', trigger: 'blur' }
			],

      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
		businessPrincipal:'',//业务负责人
		customerName:'',//客户名称
		nameOrCode:'',//合同框架名称/编号
		status:null,//盖章状态
      },
	  rlpage:{
		  pageNum: 1,
		  pageSize: 10,
		  total: 0,
	  },//认领列表分页
      submitLoading: false,
      tableData: [],
      tableLoading: false,
      /**
       * 业务负责人模块
       */
      adminListModal: false,
      adminPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      adminForm: {
        queryString: "",
      },
      selectAdminId: null,
      selectAdmin: null,
      adminTable: [],
      adminTableLoading: false,
      pid: null,
    };
  },
  mounted() {
    this.getList();
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
  methods: {
	  //删除多个
	  remClick(item,index){
	  	 this.InvoiceForm.fileList.splice(index,1)
	  		 this.$refs.uploadBtn.fileIndex.splice(index,1)
	  		 this.$refs.uploadBtn.fileList.splice(index,1)
	  },
	  //查询之前的盖章文件
	  seeBeforefile(){
			  let obj = {
				  id:this.id
			  }
			sealFile(obj)
		    .then((res) => {
				this.zfData = res.data
				console.log(this.zfData)
				this.zfData.name = res.data.sealOperatorName
				this.$refs.uploadBtn.fileList = this.zfData.fileList || []
		    })
		    .catch((err) => {
		  			
		    });
	  },
	  //申请盖章保存	  
	  sqComit(){
		  var obj =	{
		      "fileList":this.zfData.fileList,
		      "id": this.id,
		      "sealType": this.zfData.sealType,
		  	"sealOperatorId":this.zfData.sealOperatorId,
		    }
		  bcSeal(obj)
		    .then((res) => {
					this.$message({
					  type: 'success',
					  message: '保存成功!'
					});
					this.sqVisible = false
					this.getList()
		    })
		    .catch((err) => {
		  			
		    });
	  },
	  //多文件上传
	  moreClickA(item){
	  	console.log('aaaaaa',item)
	  	let a = [];
	  	item.forEach((e)=>{
	  		a.push({
				fileType: 2,
	  			name:e.name,
	  			path:e.path,
				objectId: this.id,
	  		})
	  	})
	  	this.zfData.fileList = a
		this.$refs.zfData.clearValidate()//清空表单验证
	  	this.$forceUpdate()
	  },
	  //作废
	  zfClick(id){
		  this.$confirm('确定作废框架协议?', '提示', {
		  			confirmButtonText: '确定',
		  			cancelButtonText: '取消',
		  			type: 'warning'
		  }).then(() => {
		  			  let obj = {
		  				  id:id
		  			  }
		  			  ZFAgree(obj)
		  			    .then((res) => {
		  					if(res.code==1){
		  						this.$message({
		  						  type: 'success',
		  						  message: '作废成功!'
		  						});
		  						this.getList()
		  					}
		  			    })
		  			    .catch((err) => {
		  			  			
		  			    });
		  
		  }).catch(() => {
		  			this.$message({
		  			  type: 'info',
		  			  message: '已取消'
		  			});          
		  });
	  },
	  //申请盖章
	  submitSqgz(){
		   if(this.zfData.fileList.length==0){
			  this.$message({
				type: 'error',
				message: '请先上传框架协议文件!'
			  });
			  return
			 }
			 if(this.zfData.sealType==null){
						  this.$message({
							type: 'error',
							message: '请先选择盖章类型!'
						  });
				return
			 }
			 if(this.zfData.sealOperatorId==''){
						  this.$message({
							type: 'error',
							message: '请先选择盖章经办人!'
						  });
				return
			 }
		   var obj =	{
			   "fileList":this.zfData.fileList,
			   "id": this.id,
			   "sealType": this.zfData.sealType,
			"sealOperatorId":this.zfData.sealOperatorId,
			 }
			 if(this.sqType==1){
			  sqSeal(obj)
				.then((res) => {
							if(res.code==1){
								this.$message({
								  type: 'success',
								  message: '申请盖章成功!'
								});
								this.sqVisible = false
								this.getList()
							}
				})
				.catch((err) => {
						
				});
			 }else{
			  resetSq(obj)
				.then((res) => {
							if(res.code==1){
								this.$message({
								  type: 'success',
								  message: '重新申请盖章成功!'
								});
								this.sqVisible = false
								this.getList()
							}
				})
				.catch((err) => {
						
				});
			 }
	  },
	  //重新申请盖章
	  rstestSqgz(id){
		  this.$confirm('确定重新申请盖章?', '提示', {
		  			confirmButtonText: '确定',
		  			cancelButtonText: '取消',
		  			type: 'warning'
		  }).then(() => {
			  let obj = {
				  id:id
			  }
			  resetSq(obj)
				.then((res) => {
					if(res.code==1){
						this.$message({
						  type: 'success',
						  message: '申请成功!'
						});
						this.getList()
					}
				})
				.catch((err) => {
						
				});
		  }).catch(() => {
		  			this.$message({
		  			  type: 'info',
		  			  message: '已取消'
		  			});          
		  });
	  },
	  
	  //删除框架协议
	  delKjxy(id){
		  this.$confirm('确定删除框架协议?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		  }).then(() => {
			  let obj = {
				  id:id
			  }
			  delXy(obj)
			    .then((res) => {
					if(res.code==1){
						this.$message({
						  type: 'success',
						  message: '删除成功!'
						});
						this.getList()
					}
			    })
			    .catch((err) => {
			  			
			    });

		  }).catch(() => {
			this.$message({
			  type: 'info',
			  message: '已取消删除'
			});          
		  });
		  
	  },
	  //重置搜索
	  resetForm(){
		 this.page.businessPrincipal='';
		 this.page.customerName='';
		 this.page.nameOrCode='';
		 this.page.status=null;
	  },
	  //选择经办人
	  selectPeople(row){
		  console.log(row)
		  this.zfData.sealOperatorId = row.id
		  this.zfData.name = row.username
		  this.$refs.zfData.clearValidate()//清空表单验证
		  this.$forceUpdate()
		  
	  },
	  //跳转查看
	  goSee(id) {
	  	let router = this.$router.resolve({
	  		path: "/frame/see",
	  		query: {
	  			id: id,
	  		},
	  	});
	  	window.open(router.href, "_blank");
	  },
	  //上传方法
	  beforeUpload(file) {
		 console.log(1111111,file)
		  qiniuToken()
			.then((res) => {
			  let that = this;
			  let fileName = Date.now() + file.name;
			  var observable = qiniu.upload(file, fileName, res.data);
			  observable.subscribe({
				next(res) {
				  console.log("upload...", res);
				},
				error(error) {
				  this.$message.error("上传失败");
				  console.log("error", error);
				},
				complete: (complete) => {
				  console.log("complete");
				  let qiniuBaseUrl = "https://yhgtk.fruitbloom.com.cn/";
				  this.$set(this.form, "fileName", file.name);
				  this.$set(this.form, "path", qiniuBaseUrl + complete.key);
				  console.log(qiniuBaseUrl + complete.key)
				  this.zfData.fileList[0].name = file.name
				   this.zfData.fileList[0].path = qiniuBaseUrl + complete.key
				},
			  });
			})
			.catch((error) => {});
		  return false;
	  },
	  //申请盖章or重新申请盖章
	  sqgz(id,type){
		 
		this.sqVisible = true
		this.id = id
		this.sqType = type
		this.seeBeforefile()
	  },
	  
	  
	  //跳转认领
	  gzEdit(id){
		  let router = this.$router.push({
		    path: "/business/frameAccord/edit",
		    query: {
		      id: id,
		    },
		  });
		  window.open(router.href, "_blank");
		  window.open("about:blank","_self").close()
		  window.close();//关闭当前页面
	  },
	// 查看详情
	gzInfo(id){
	  this.Invoicedialog = true
	  var obj = {
		  id:id
	  }
	  getGzInfo(obj)
	    .then((res) => {
			console.log('盖章详情',res)
			this.gzData = res.data
			var str1 = '';
			if(this.gzData.waitApproveNameList){
				this.gzData.waitApproveNameList.forEach((e)=>{
					str1+=e+';'
				})
			}

			this.waitApproveNameList = str1
			
			console.log(str1)
	    })
	    .catch((err) => {
	  			
	    });
	  // hkInfo(id)
	  //   .then((res) => {
	  // 			this.InvoiceForm  = res.data
	  //   })
	  //   .catch((err) => {
	  			
	  //   });
	},
	//打开认领记录
	openrlList(id){
			this.approveVisible = true
			this.hkid = id
			this.getRl();
	},
	// 获取认领记录
	getRl(){
		let obj = {
			id:this.hkid,
			pageNum:this.rlpage.pageNum,
			pageSize:this.rlpage.pageSize,
		}
		rlList(obj)
		  .then((res) => {
				console.log('我是认领记录',res)
				this.rlData = res.data
				this.rlpage.total = res.total;
				console.log('我是认领记录总数',this.rlpage.total)
		  })
		  .catch((err) => {
					
		  });
	},
	// 上传凭证
	  handleRemove(file, fileList) {
		console.log(file, fileList);
	  },
	  handlePreview(file) {
		console.log(file);
	  },
	  handleExceed(files, fileList) {
		this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
	  },
	  beforeRemove(file, fileList) {
		return this.$confirm(`确定移除 ${ file.name }？`);
	  },
    /**重新提交 */
    reSubmit(contractId) {
      this.$confirm("确认重新提交启动审批?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          reapply({ contractId }).then((res) => {
            this.$message.success("重新提交成功");
            this.getList();
          });
        })
        .catch(() => {});
    },
    /**
     * 业务负责人模块
     */
    //打开资源选择弹窗
    onOpenAdminSelectModal(username, id, pid) {
      if (username) {
        this.selectAdmin = {
          username,
          id,
        };
      } else {
        this.selectAdmin = null;
      }
      this.pid = pid;
      this.adminListModal = true;
    },
    //资源选择弹窗打开
    openAdminSelectModal() {
      this.adminForm.queryString = "";
      this.selectAdminId = null;
      this.onAdminSearch();
    },
    //资源标签删除
    onAdminTagClose() {
      this.selectAdmin = null;
      this.selectAdminId = null;
    },
    //资源弹窗关闭
    onConfirmAdminChoose() {
      if (this.selectAdmin) {
        let obj = {
          businessPrincipalId: this.selectAdmin.id,
          contractId: this.pid,
        };
        editAdmin(obj)
          .then((res) => {
            if (res.code == 1) {
              this.$message.success("分配成功！");
              this.getList();
            }
          })
          .catch((err) => {});
        this.adminListModal = false;
      } else {
        this.$message.error("不能删除业务负责人！");
      }
    },
    /**认领列表
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    rlSizeChange(val) {
      this.rlpage.pageNum = 1;
      this.rlpage.pageSize = val;
      this.getRl();
    },
    /**认领列表
     * 监听页数变化
     * @param val 当前页数
     */
    rlCurrentChange(val) {
      this.rlpage.pageNum = val;
      this.getRl();
    },
    //资源搜索
    onAdminSearch() {
      this.adminPage.pageNum = 1;
      this.getAdminList();
    },
    //获取资源列表
    getAdminList() {
      let obj = {
        pageSize: this.adminPage.pageSize,
        pageNum: this.adminPage.pageNum,
      };
      if (this.adminForm.queryString && this.adminForm.queryString.trim()) {
        obj.usernameOrPhone = this.adminForm.queryString.trim();
      }
      this.adminTableLoading = true;
      listAdmin(obj)
        .then((res) => {
          this.adminTable = res.data || [];
          this.adminPage.total = res.total;
          this.adminTableLoading = false;
        })
        .catch((err) => {
          this.adminTable = [];
          this.adminPage.total = 0;
          this.adminTableLoading = false;
        });
    },
    //资源选择变化
    onChangeAdmin(val) {
      console.log(this.selectAdminId);
      this.selectAdmin = this.adminTable.find((v) => v.id == val);
    },

    //提交
    onSubmit() {
      this.$refs.InvoiceForm.validate((valid, obj) => {
        if (valid) {
          let f = util.deepClone(this.InvoiceForm);
          InvoiceAdd(f).then((res) => {
            if (res.code == 1) {
              this.$message.success("申请成功！");
              this.Invoicedialog = false;
              this.getList();
            }
          });
        } else {
          let a = Object.keys(obj).map((v) => {
            let text = "";
            if (!InvoiceFormFields.list[v] && v.lastIndexOf(".") !== -1) {
              let fieldInArray = v.substring(v.lastIndexOf(".") + 1, v.length);
              text = InvoiceFormFields.list[fieldInArray];
            } else {
              text = InvoiceFormFields.list[v];
            }
            return text;
          });
          this.$message.error(
            "表单不完整！请检查" + a.join("、") + "是否按要求填写"
          );
        }
      });
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },

    // 搜索
    onSearch() {
      // if (this.form.contractMoneyMin && this.form.contractMoneyMax) {
      //   if (
      //     parseInt(this.form.contractMoneyMin) >
      //     parseInt(this.form.contractMoneyMax)
      //   ) {
      //     this.$message.error("最小合同金额不能大于最大合同金额");
      //     return;
      //   }
      // }
      this.page.pageNum = 1;
      this.getList();
    },
    // 获取列表
    getList() {
      this.tableLoading = true;
      getXyList(this.page)
        .then((res) => {
			console.log(res)
          this.tableData = res.data || [];
          this.page.total = res.total;
          this.tableLoading = false;
        })
        .catch((err) => {
			
        });
    },

    /**
     * 跳转到编辑页
     */
    toEdit(id) {
      let router = this.$router.resolve({
        path: "/business/contract/edit",
        query: {
          id: id,
        },
      });
      window.open(router.href, "_blank");
    },
    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },
  },
  watch: {
    Invoicedialog(val) {
      if (!val) {
        this.InvoiceForm = {
          contractId: null, //合同ID
          customerName: "", //名称
          companyPhone: "", //电话
          companyAddress: "", //公司地址
          taxpayerId: "", //纳税人识别号
          customerBank: "", //客户开户行
          customerBankAccount: "", //客户银行账户
          invoiceMoney: "", //开票金额
          invoiceType: "", //发票类型
          invoiceDetail: "", //开票明细
          remark: "", //合同备注
        };
        // this.$refs.InvoiceForm.clearValidate("invoiceMoney");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table-wrap{
	margin-top: 20px;
}
.mar-c {
  display: flex;
  justify-content: center;
}
.table-count {
  margin: 15px 0 10px;
}
// 列表item
.block-form-item {
  &.w-32 {
    display: inline-block;
    width: 32%;
    margin-right: 1%;
    height: 64px;
  }

  &.w-99 {
    width: 99%;
    margin-right: 1%;
  }
}
.yhg-dialog {
  .select-con {
    display: flex;
    .label {
      white-space: nowrap;
    }
    .select-tag {
      margin-right: 5px;
      margin-bottom: 5px;
    }
    .select-tag-text {
      display: inline-block;
      max-width: 86px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .filter-con {
    display: flex;
    align-items: center;
    margin: 20px 0;
    width: 800px;
    .label {
      white-space: nowrap;
    }
    .search-btn {
      margin-left: 15px;
    }
  }
  .submit-con {
    margin-top: 20px;
    text-align: right;
  }
}
  .el-input-group__append {
    position: relative;
    width: 32px;
    height: 32px;
    border: none;
    background: #fff;
    padding: 0;
    color: #409eff !important;
    .iconfont {
      position: absolute;
      top: 0;
      left: 0;
	  right: 0;
	  bottom: 0;
	  margin: auto;
      font-size: 33px !important;
	   color: #409eff !important;
	   margin: 0 auto !important;
	   text-align: center !important;
    }
    cursor: pointer;
  }
.select-con {
  .el-tag .el-icon-close {
    top: -8px;
  }
}
.avue-view .cost-table {
  width: calc(50% + 100px);
  th {
    background: none;
    font-weight: normal;
    font-size: 14px;
  }
  .cell {
    padding-left: 0;
  }
}
.el-table .operate-column {
  vertical-align: text-top;
}
/deep/.el-dialog__header {
  border-bottom: 1px solid #ccc !important;
}
.invoiceList {
  display: flex;
  justify-content: space-between;
}
.mt-10 {
  margin-top: 10px;
}
</style>